"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t={OpenDialog:function(){const{body:t}=document,e=t.children,o="undefined"!=typeof document?document.getElementById("tooltip-portal"):null;for(let t=0;t<e.length;t++){const n=e[t];n.setAttribute&&n!==o&&"SCRIPT"!==n.tagName&&(n.setAttribute("data-old-aria-hidden",n.ariaHidden||"null"),n.setAttribute("aria-hidden","true"))}},CloseDialog:function(){const{body:t}=document,e=t.children;for(let t=0;t<e.length;t++){const o=e[t];o.setAttribute&&(o.removeAttribute("data-old-aria-hidden"),o.removeAttribute("aria-hidden"),o.removeAttribute("inert"))}}};exports.default=t;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/tooltips/cjs/components/util/screen-reader.js
// module id = 1334
// module chunks = 0